export enum ChannelLoudspeaker {
	Generic = 'GENERIC',
	Mxp1 = 'MXP_1',
	Mxp3 = 'MXP_3',
	Mxp5 = 'MXP_5',
	Mxp6 = 'MXP_6'
}
